// 导入所有 svg 图标
const svgRequire = import.meta.glob('./svg/*.svg', { eager: true })

// 解析 SVG 内容并注册为 Symbol
const loadSvg = () => {
  try {
    
    const symbols = Object.entries(svgRequire).map(([key, module]) => {
      const name = key.match(/\.\/svg\/(.*)\.svg/)[1]
      // 直接使用导入的内容
      const content = module.default
      
      // 创建一个临时的 div 来解析 SVG 内容
      const div = document.createElement('div')
      div.innerHTML = content
      
      // 获取 SVG 元素
      const svg = div.querySelector('svg')
      const viewBox = svg.getAttribute('viewBox') || '0 0 1024 1024'
      const path = svg.innerHTML
      
      
      return `
        <symbol id="icon-${name}" viewBox="${viewBox}">
          ${path}
        </symbol>
      `
    })

    const svgSprite = `
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        xmlns:xlink="http://www.w3.org/1999/xlink"
        id="__svg__icons__sprite__"
        style="position: absolute; width: 0; height: 0; overflow: hidden;"
        version="1.1"
      >
        <defs>
          ${symbols.join('')}
        </defs>
      </svg>
    `

    // 检查是否已存在 sprite
    const existingSprite = document.getElementById('__svg__icons__sprite__')
    if (existingSprite) {
      existingSprite.remove()
    }

    const container = document.createElement('div')
    container.style.display = 'none'
    container.innerHTML = svgSprite
    document.body.insertBefore(container.firstElementChild, document.body.firstChild)
    
    console.log('SVG icons loaded successfully')
  } catch (error) {
    console.error('Error loading SVG icons:', error)
  }
}

export default {
  install(app) {
    if (typeof window !== 'undefined') {
      // 直接执行，不需要等待 DOMContentLoaded
      loadSvg()
    }
  }
} 